import { h } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./CircleLoader.module.css";

interface Props {
    class?: string;
}

function CircleLoader({
    class: cssClass
}: Props) {
    return (
        <div class={classname(styles.circleLoader, cssClass)}>
            <div class={styles.background}/>
            <div class={styles.loader}/>
        </div>
    );
}

export default CircleLoader;
